import LandingPricing from '#app/components/landing-pricing.tsx'
import { type Route } from './+types/plans.ts'

export const meta: Route.MetaFunction = () => [{ title: 'Plans | Podly' }]

export default function PlansRoute() {
	return (
		<main className="text-base-content font-poppins flex min-h-screen flex-col bg-gradient-to-b from-background via-indigo-500/5 to-purple-500/10">
			<LandingPricing />
		</main>
	)
}
